module.exports = __webpack_public_path__ + "static/media/ShirbitLogo.942b91bf.png";